import { useQuery } from '@tanstack/react-query';
import { historicoPrecosService } from '../services/historicoPrecosService';

export const useHistoricoPrecos = (params: {
  produtoId?: number;
  fornecedorId?: number;
  pagina?: number;
  tamanhoPagina?: number;
}) =>
  useQuery({
    queryKey: ['historico-precos', params],
    queryFn:  () => historicoPrecosService.getAll(params),
  });
